import { render, staticRenderFns } from "./Industry-report.vue?vue&type=template&id=1da90f18&scoped=true&"
import script from "./Industry-report.vue?vue&type=script&lang=js&"
export * from "./Industry-report.vue?vue&type=script&lang=js&"
import style0 from "./Industry-report.vue?vue&type=style&index=0&id=1da90f18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da90f18",
  null
  
)

export default component.exports